import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Switch,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import axios from "axios";
import PermissionChangesSaved from "./PermissionChangesSaved";
import ResetWarning from "./ResetWarning";
import { appUrl } from "../../../../../../utils/config";
import moment from "moment";

// const initialScreensAndFeaturesData = [
//   {
//     screen_id: 1,
//     screen_name: "GRN Receipts Dashboard",
//     screen_access: true,
//     features: [
//       {
//         feature_id: 1,
//         feature: "Export to Excel",
//         feature_access: true,
//         last_updated_date: "02-OCT-2025",
//       },
//       {
//         feature_id: 2,
//         feature: "Approve GR",
//         feature_access: true,
//       },
//       {
//         feature_id: 3,
//         feature: "View GR Details",
//         feature_access: true,
//       },
//       {
//         feature_id: 4,
//         feature: "Download GR Files",
//         feature_access: false,
//         last_updated_date: "02-OCT-2025",
//       },
//     ],
//   },
//   {
//     screen_id: 2,
//     screen_name: "Schedule Agreements",
//     screen_access: false,
//     features: [
//       {
//         feature_id: 5,
//         feature: "View Schedule",
//         feature_access: false,
//         last_updated_date: "01-OCT-2025",
//       },
//     ],
//   },
//   {
//     screen_id: 3,
//     screen_name: "Delivery Schedule Details",
//     screen_access: true,
//     features: [
//       {
//         feature_id: 6,
//         feature: "Edit Delivery Schedule",
//         feature_access: true,
//         last_updated_date: "02-OCT-2025",
//       },
//       {
//         feature_id: 7,
//         feature: "Delete Delivery Schedule",
//         feature_access: false,
//       },
//     ],
//   },
//   {
//     screen_id: 4,
//     screen_name: "FG Batch",
//     screen_access: true,
//     features: [
//       {
//         feature_id: 8,
//         feature: "View FG Batch Details",
//         feature_access: true,
//         last_updated_date: "02-OCT-2025",
//       },
//     ],
//   },
// ];

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#1890ff",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#1890ff",
    },
  },
  heading: {
    fontWeight: 600,
    marginBottom: "1em",
  },
  resetText: {
    color: "#87abe4",
    fontSize: "12px",
    fontWeight: 500,
    cursor: "pointer",
    textDecoration: "underline",
    marginBottom: theme.spacing(1),
  },
  listContainer: {
    border: "1px solid #ccc",
    padding: 0,
    marginBottom: theme.spacing(2),
  },
  screen: {
    padding: theme.spacing(1),
    backgroundColor: "#f5f5f5",
  },
  feature: {
    padding: theme.spacing(1),
    borderTop: "1px solid #ccc",
  },
  content: {
    flexGrow: 1,
    // backgroundColor: "red",
    // height: "100%",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: "auto",
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  drawerPaper: {
    width: "30vw",
  },
}));

export default function AccessAndPermissions({
  user,
  setViewDetailsDrawer,
  handleRefresh,
  selectedRole
}) {
  const classes = useStyles();
  const [expandedSections, setExpandedSections] = useState({});
  const [apiData, setApiData] = useState([]);
  const [screensAndFeatures, setScreensAndFeatures] = useState([]);
 const [defaultData, setDefaultData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [changesSavedDrawer, setChangesSavedDrawer] = useState(false);
  const [resetDrawer, setResetDrawer] = useState(false);
  const [count, setCount] = useState({ enabled: 0, disabled: 0 });
  const [reset, setReset] = useState(false);

  useEffect(() => {
    setLoading(true);
    setError(null);
    // const url = "https://run.mocky.io/v3/99ad4213-c081-454f-acee-31d7ebe1f1d2";
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchScreensAndFeatures/${user.collaborator_role_id}/${user.saas_user_id}`;
    axios
      .get(url)
      .then((res) => {
        if (res.data.status) {
          setApiData(res.data.data.screensAndFeatures);
          setScreensAndFeatures(res.data.data.screensAndFeatures);
        }
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [reset]);

    useEffect(() => {
    setLoading(true);
    setError(null);
    // const url = "https://run.mocky.io/v3/99ad4213-c081-454f-acee-31d7ebe1f1d2";
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchScreensAndFeatures/${user.collaborator_role_id}/0`;
    axios
      .get(url)
      .then((res) => {
        if (res.data.status) {
          setDefaultData(res.data.data.screensAndFeatures);
          // setScreensAndFeatures(res.data.data.screensAndFeatures);
        }
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [reset]);


  const handleExpand = (screenId) => {
    setExpandedSections((prev) => ({
      ...prev,
      [screenId]: !prev[screenId],
    }));
  };
  const handleToggleScreen = (screenId) => {
    setScreensAndFeatures((prev) =>
      prev.map((screen) =>
        screen.screen_id === screenId
          ? {
            ...screen,
            screen_access: !screen.screen_access,
            features: screen.screen_access
              ? screen.features.map((feature) => ({
                ...feature,
                feature_access: false, // Turn off all features if screen is turned off
              }))
              : screen.features, // Leave features unchanged when turning on
          }
          : screen
      )
    );
  };
  const handleToggleFeature = (screenId, featureId) => {
    setScreensAndFeatures((prev) =>
      prev.map((screen) =>
        screen.screen_id === screenId
          ? {
            ...screen,
            features: screen.features.map((feature) =>
              feature.feature_id === featureId
                ? { ...feature, feature_access: !feature.feature_access }
                : feature
            ),
          }
          : screen
      )
    );
  };

  const calculateChangedAccessCounts = () => {
    let enabledScreens = 0;
    let disabledScreens = 0;
    let enabledFeatures = 0;
    let disabledFeatures = 0;

    screensAndFeatures.forEach((screen, screenIndex) => {
      const originalScreen = apiData.find((s) => s.screen_id === screen.screen_id);

      if (!originalScreen) return;

      // Check if the screen access has changed
      if (screen.screen_access !== originalScreen.screen_access) {
        if (screen.screen_access) {
          enabledScreens++;
        } else {
          disabledScreens++;
        }
      }

      // Check if any feature access has changed
      screen.features.forEach((feature) => {
        const originalFeature = originalScreen.features.find(
          (f) => f.feature_id === feature.feature_id
        );

        if (!originalFeature) return;

        if (feature.feature_access !== originalFeature.feature_access) {
          if (feature.feature_access) {
            enabledFeatures++;
          } else {
            disabledFeatures++;
          }
        }
      });
    });

    return {
      enabledScreens,
      disabledScreens,
      enabledFeatures,
      disabledFeatures,
    };
  };

  const calculateAccessType = () => {
    let hasRestrictions = false;

    screensAndFeatures.forEach((screen) => {
      const defaultScreen = defaultData.find((s) => s.screen_id === screen.screen_id);

      if (!defaultScreen) return;

      // Check if the screen access is restricted compared to default
      // Only consider it a restriction if user has LESS than default (not MORE)
      if (!screen.screen_access && defaultScreen.screen_access) {
        hasRestrictions = true;
      }

      // Check if any feature access is restricted compared to default  
      // Only consider it a restriction if user has LESS than default (not MORE)
      screen.features.forEach((feature) => {
        const defaultFeature = defaultScreen.features.find(
          (f) => f.feature_id === feature.feature_id
        );

        if (!defaultFeature) return;

        if (!feature.feature_access && defaultFeature.feature_access) {
          hasRestrictions = true;
        }
      });
    });

    return hasRestrictions ? "Partial" : "Full";
  };

  // const calculateFeatureChanges = () => {
  //   let newlyEnabledCount = 0;
  //   let newlyDisabledCount = 0;

  //   screensAndFeatures.forEach((screen, screenIndex) => {
  //     screen.features.forEach((feature) => {
  //       const initialFeature = apiData[screenIndex].features.find(
  //         (f) => f.feature_id === feature.feature_id
  //       );
  //       if (feature.feature_access && !initialFeature.feature_access) {
  //         newlyEnabledCount++;
  //       } else if (!feature.feature_access && initialFeature.feature_access) {
  //         newlyDisabledCount++;
  //       }
  //     });
  //   });
  //   return { newlyEnabledCount, newlyDisabledCount };
  // };

  //send only enabled screens and features
  // const preparePayload = () => {
  //   return {
  //     saas_user_id: user.saas_user_id,
  //     screenAndFeatures: screensAndFeatures
  //       .filter((screen) => screen.screen_access) // Only include screens with access
  //       .map((screen) => ({
  //         screen_id: screen.screen_id,
  //         screen_name: screen.screen_name,
  //         screen_access: screen.screen_access,
  //         features: screen.features
  //           .filter((feature) => feature.feature_access) // Only include features with access
  //           .map((feature) => ({
  //             feature_id: feature.feature_id,
  //             feature: feature.feature,
  //             feature_access: feature.feature_access,
  //           })),
  //       })),
  //   };
  // };

  //send only modified screens and features
  // const preparePayload = () => {

  // if (user.access === null) {
  //   const enabledScreens = screensAndFeatures
  //     .filter((screen) => screen.screen_access) // only toggled on screens
  //     .map((screen) => ({
  //       screen_id: screen.screen_id,
  //       screen_name: screen.screen_name,
  //       screen_access: screen.screen_access, 
  //       features: screen.features
  //         .filter((feature) => feature.feature_access) // only toggled on features
  //         .map((feature) => ({
  //           feature_id: feature.feature_id,
  //           feature: feature.feature,
  //           feature_access: feature.feature_access,
  //         })),
  //     }));

  //   return {
  //     saas_user_id: user.saas_user_id,
  //     access: "Partial", // Since only enabled ones are sent, treat as Partial
  //     screenAndFeatures: enabledScreens,
  //   };
  // }

  //   const modifiedScreens = screensAndFeatures
  //     .map((screen) => {
  //       const originalScreen = apiData.find(
  //         (s) => s.screen_id === screen.screen_id
  //       );
  //       if (!originalScreen) return null;

  //       const isScreenAccessChanged =
  //         screen.screen_access !== originalScreen.screen_access;

  //       const modifiedFeatures = screen.features.filter((feature) => {
  //         const originalFeature = originalScreen.features.find(
  //           (f) => f.feature_id === feature.feature_id
  //         );
  //         return (
  //           originalFeature &&
  //           feature.feature_access !== originalFeature.feature_access
  //         );
  //       });

  //       const isAnyFeatureChanged = modifiedFeatures.length > 0;

  //       if (isScreenAccessChanged || isAnyFeatureChanged) {
  //         return {
  //           screen_id: screen.screen_id,
  //           screen_name: screen.screen_name,
  //           screen_access: screen.screen_access,
  //           features: modifiedFeatures.map((feature) => ({
  //             feature_id: feature.feature_id,
  //             feature: feature.feature,
  //             feature_access: feature.feature_access,
  //           })),
  //         };
  //       }

  //       return null;
  //     })
  //     .filter((screen) => screen !== null);

  //     const {disabledScreens,disabledFeatures} = calculateChangedAccessCounts();
     
  //   return {
  //     saas_user_id: user.saas_user_id,
  //     access : disabledScreens + disabledFeatures > 0 ? "Partial" : "Full",
  //     screenAndFeatures: modifiedScreens,
  //   };
  // };

  const preparePayload = () => {
  // Case 1: If user.access is null, send all screens/features that are toggled ON (true)
  if (user.access === null) {
    const enabledScreens = screensAndFeatures
      .filter((screen) => screen.screen_access) // only toggled on screens
      .map((screen) => ({
        screen_id: screen.screen_id,
        screen_name: screen.screen_name,
        screen_access: screen.screen_access,
        features: screen.features
          .filter((feature) => feature.feature_access) // only toggled on features
          .map((feature) => ({
            feature_id: feature.feature_id,
            feature: feature.feature,
            feature_access: feature.feature_access,
          })),
      }));
 const accessType = calculateAccessType();
    return {
      saas_user_id: user.saas_user_id,
      access: accessType, // Since only enabled ones are sent, treat as Partial
      screenAndFeatures: enabledScreens,
    };
  }

  // Case 2: Default – Only send modified ones (as in original code)
  const modifiedScreens = screensAndFeatures
    .map((screen) => {
      const originalScreen = apiData.find(
        (s) => s.screen_id === screen.screen_id
      );
      if (!originalScreen) return null;

      const isScreenAccessChanged =
        screen.screen_access !== originalScreen.screen_access;

      const modifiedFeatures = screen.features.filter((feature) => {
        const originalFeature = originalScreen.features.find(
          (f) => f.feature_id === feature.feature_id
        );
        return (
          originalFeature &&
          feature.feature_access !== originalFeature.feature_access
        );
      });

      const isAnyFeatureChanged = modifiedFeatures.length > 0;

      if (isScreenAccessChanged || isAnyFeatureChanged) {
        return {
          screen_id: screen.screen_id,
          screen_name: screen.screen_name,
          screen_access: screen.screen_access,
          features: modifiedFeatures.map((feature) => ({
            feature_id: feature.feature_id,
            feature: feature.feature,
            feature_access: feature.feature_access,
          })),
        };
      }

      return null;
    })
    .filter((screen) => screen !== null);

  const accessType = calculateAccessType();

  return {
    saas_user_id: user.saas_user_id,
    access: accessType,
    screenAndFeatures: modifiedScreens,
  };
};

  const handleSave = () => {
    setLoading(true);
    setError(null);

    // const { newlyEnabledCount, newlyDisabledCount } = calculateFeatureChanges();
    const { enabledScreens, disabledScreens, enabledFeatures, disabledFeatures } = calculateChangedAccessCounts();
    const payload = preparePayload();
    // console.log("🚀 ~ handleSave ~ payload:", payload);

    // const url = `${appUrl}/user/updateUserMapping`;
    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateUserMapping`;
    axios
      .post(url, payload)
      .then((res) => {
        if (res.data.status) {
          setCount({
            enabled: enabledScreens + enabledFeatures,
            disabled: disabledScreens + disabledFeatures,
          });
          setChangesSavedDrawer(true);
        }
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });


    const accessType = calculateAccessType();
    const requestObject = [
      {
        saas_user_id: user.saas_user_id,
        access: accessType,
      },
    ];
    // console.log("🚀 ~ handleConfirm ~ requestObject:", requestObject);
    // const url = "/updateUserDetails";
    axios
      .post(`${appUrl}/user/updateTeamMemberDetails`, requestObject)
      .then((res) => {
      })
      .catch((err) => {
        //console.log("API Error", err.message);
      })
  };

  const handleDiscard = () => {
    setScreensAndFeatures(apiData);
  };
  const displayLoading = (
    <div style={{ textAlign: "center", marginTop: "1.5em" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );
  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",

        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginTop: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  const displayNoRecordsFound = (
    <Box
      style={{
        display: "flex",
        justifyContent: "center", // Horizontally center the CircularProgress
        alignItems: "center", // Vertically center the CircularProgress
        height: "50px", // Optional: Set a height to vertically center the loader
        border: "2px solid #000",
        // backgroundColor: "#FFF0F0",
        width: "100%",
        marginTop: "1.5em",
      }}
    >
      <Typography style={{ textAlign: "center" }}>No records found</Typography>
    </Box>
  );

  const displayList = (
    <List className={classes.listContainer}>
      {screensAndFeatures?.map((screen) => (
        <React.Fragment key={screen.screen_id}>
          <ListItem
            button
            className={classes.screen}
            onClick={() => handleExpand(screen.screen_id)}
          >
            <ListItemIcon
              style={{
                visibility:
                  screen.features && screen.features.length > 0
                    ? "visible"
                    : "hidden",
              }}
            >
              {expandedSections[screen.screen_id] ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </ListItemIcon>
            <ListItemText>
              <Typography style={{ fontSize: "14px" }}>
                {screen.screen_name}
              </Typography>
            </ListItemText>
            <Switch
              classes={{ root: classes.root }}
              checked={screen.screen_access}
              onClick={(e) => e.stopPropagation()}
              onChange={() => handleToggleScreen(screen.screen_id)}
            />
          </ListItem>
          {screen.features && screen.features.length > 0 && (
            <Collapse
              in={expandedSections[screen.screen_id]}
              timeout="auto"
              unmountOnExit
            >
              <List>
                {screen.features.map((feature) => (
                  <ListItem
                    key={feature.feature_id}
                    className={classes.feature}
                  >
                    <Box style={{ flex: 1 }}>
                      <ListItemText>
                        <Typography style={{ fontSize: "14px" }}>
                          {feature.feature}
                        </Typography>
                      </ListItemText>
                    </Box>
                    <Box>
                      <Switch
                        classes={{ root: classes.root }}
                        checked={feature.feature_access}
                        onChange={() =>
                          handleToggleFeature(
                            screen.screen_id,
                            feature.feature_id
                          )
                        }
                        disabled={!screen.screen_access}
                      />
                    </Box>
                    <Box style={{ flex: 1, textAlign: "right" }}>
                      {feature.last_updated_date && (
                        <Typography variant="body2" color="textSecondary">
                          <ListItemText>
                            {" "}
                            <Typography style={{ fontSize: "14px" }}>
                              {moment(feature.last_updated_date).format(
                                "DD-MMM-YYYY"
                              )}
                            </Typography>
                          </ListItemText>
                        </Typography>
                      )}
                    </Box>
                  </ListItem>
                ))}
              </List>
            </Collapse>
          )}
        </React.Fragment>
      ))}
    </List>
  );
  if (loading) return displayLoading;
  if (error) return displayError;
  if (apiData.length === 0) return displayNoRecordsFound;

  return (
    <Box
      style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <Typography className={classes.heading}>
        Access and Permissions
      </Typography>
      <Typography
        className={classes.resetText}
        onClick={() => setResetDrawer(true)}
      >
        Reset to Default
      </Typography>
      <Drawer
        anchor="right"
        open={resetDrawer}
        onClose={() => setResetDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{ style: { backgroundColor: "transparent" } }} // ✅ Removes backdrop
      >
        <ResetWarning
          setResetDrawer={setResetDrawer}
          setReset={setReset}
          user={user}
          handleRefresh={handleRefresh}
          setViewDetailsDrawer={setViewDetailsDrawer}
        />
      </Drawer>
      <Box className={classes.content}>{displayList}</Box>
      <Box className={classes.buttonContainer}>
        <Button
          size="small"
          variant="contained"
          onClick={handleDiscard}
          style={{ textTransform: "none" }}
        >
          Discard Changes
        </Button>
        <Button
          size="small"
          variant="contained"
          style={{
            textTransform: "none",
            backgroundColor: "#286acf",
            color: "#fff",
          }}
          onClick={handleSave}
        >
          Save Changes
        </Button>
      </Box>
      <Drawer
        anchor="right"
        open={changesSavedDrawer}
        onClose={() => setChangesSavedDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
      >
        <PermissionChangesSaved
          setChangesSavedDrawer={setChangesSavedDrawer}
          count={count}
          setReset={setReset}
          user={user}
          setViewDetailsDrawer={setViewDetailsDrawer}
          handleRefresh={handleRefresh}
          selectedRole={selectedRole}
        />
      </Drawer>
    </Box>
  );
}
